/**
 * @desc 批量审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.FirstBatchApproveRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/firstTrialOrder/batchApprove`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
